export default "__VITE_ASSET__sV9T97eE__"